interface SeoTrackingEvent {
    eventName: string
}

const emitSeoTrackingEvent = (eventDto: SeoTrackingEvent) => {
    try {
        const { eventName, ...eventProps } = eventDto
        // @ts-ignore
        window.dataLayer.push({
            event: eventName,
            ...eventProps,
        })
    } catch (exception) {
        console.error(exception)
    }
}

export type { SeoTrackingEvent }
export { emitSeoTrackingEvent }
